export default "__VITE_PUBLIC_ASSET__db202cee__"